type nil = null | undefined;

export default class Func {
  // null check
  static isNull(v: unknown) {
    return v === null;
  }
  static isNotNull<T>(v: T | null) {
    return v !== null;
  }

  // undefined check
  static isUndefined(v: unknown) {
    return v === undefined;
  }
  static isNotUndefined<T>(v: T | undefined) {
    return v !== undefined;
  }

  // nil check (null | undefined)
  static isNil(v: unknown) {
    return v == null;
  }
  static isNotNil<T>(v: T | nil) {
    return v != null;
  }

  // string check
  static stringIsEmpty(v: string) {
    if (typeof v !== "string") throw Error("Given value is not string");
    return v === "";
  }
  static stringIsEmptyOrNil(v: string | nil) {
    return this.isNil(v) || v === "";
  }
  static stringIsNotEmpty(v: string) {
    if (typeof v !== "string") throw Error("Given value is not string");
    return v !== "";
  }
  static stringIsNotEmptyOrNil(v: string | nil) {
    return this.isNotNil(v) && v !== "";
  }
  static stringIsBlank(v: string) {
    if (typeof v !== "string") throw Error("Given value is not string");
    return v.trim() === "";
  }
  static stringIsBlankOrNil(v: string | nil) {
    return this.isNil(v) || (typeof v === "string" && v.trim() === "");
  }
  static stringIsNotBlank(v: string) {
    if (typeof v !== "string") throw Error("Given value is not string");
    return v.trim() !== "";
  }
  static stringIsNotBlankOrNil(v: string | nil) {
    return this.isNotNil(v) && v.trim() !== "";
  }

  // number check
  static numberIsZero(v: number) {
    if (typeof v !== "number") throw Error("Given value is not number");
    return v === 0;
  }
  static numberIsZeroOrNil(v: number | nil) {
    return this.isNil(v) || v === 0;
  }
  static numberIsNotZero(v: number) {
    if (typeof v !== "number") throw Error("Given value is not number");
    return v !== 0;
  }
  static numberIsNotZeroOrNil(v: number | nil) {
    return this.isNotNil(v) && v !== 0;
  }
  static numberIsPositive(v: number) {
    if (typeof v !== "number") throw Error("Given value is not number");
    return v >= 0;
  }
  static numberIsNegative(v: number) {
    if (typeof v !== "number") throw Error("Given value is not number");
    return v < 0;
  }
}
